import React, { useState, useEffect } from "react";
import Error from "components/form/Error";
import InputArea from "./InputArea";
import LabelArea from "components/form/LabelArea";
import ConfirmDeleteModal from "./ConfirmDeleteModal";

const DynamicCancellationPolicy = ({
  setDataInput,
  dataInput,
  policy,
  tab,
  register,
  errors,
}) => {

  // Transform policy object into array of days and percentages
  useEffect(() => {
    if (Array.isArray(policy) && policy.length > 0) {
      const transformedPolicy = Object.entries(policy[0].policy).map(
        ([days, percentage], index) => ({
          [`days_${index}`]: days,
          [`percentage_${index}`]: percentage,
        })
      );
      setDataInput(transformedPolicy);
    }
    // eslint-disable-next-line 
  }, [policy]);

  // Handle input change
  // const handleChangeInput = (e, i) => {
  //   const { name, value } = e.target;
  //   const updatedInput = [...dataInput];
  //   updatedInput[i][name] = value;
  //   setDataInput(updatedInput);
  // };
  const handleChangeInput = (e, i) => {
    const { name, value } = e.target;
    const updatedInput = [...dataInput];
    if (value === "") {
      updatedInput[i][name] = "";
      setDataInput(updatedInput);
      return;
    }

    if (tab === 0 || tab === 2 || tab === 3) {
      if (name.includes("days_") && (isNaN(value) || value < 0 || value > 31)) {
       // console.log("Invalid number. Days must be between 1 and 31.");
        return;
      }
      if (
        name.includes("percentage_") &&
        (isNaN(value) || value < 1 || value > 100)
      ) {
        //console.log("Invalid number. Percentage must be between 1 and 100.");
        return;
      }
    } else if (tab === 1) {
      if (
        name.includes("days_") &&
        !/^([01]\d|2[0-3]):([0-5]\d)$/.test(value)
      ) {
        //   console.log("Invalid time format. Expected HH:MM.");
        return;
      }
    }

    updatedInput[i][name] = value;
    setDataInput(updatedInput);
  };

  // Handle adding a new row
  const handleClick = () => {
    setDataInput((prev) => [
      ...prev,
      { [`days_${prev.length}`]: "", [`percentage_${prev.length}`]: "" },
    ]);
  };

  // Handle delete action
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  // const handleDelete = () => {
  //   if (deleteIndex !== null) {
  //     setDataInput((prev) => {
  //       const updatedData = prev.filter((_, index) => index !== deleteIndex);
  //       console.log(updatedData, "updatedData");
  //       return updatedData;
  //     });

  //     setDeleteIndex(null);
  //     setShowDeleteModal(false);

  //   }

  // };
  const handleDelete = () => {
    if (deleteIndex !== null) {
      setDataInput((prev) => {
        const updatedData = prev.filter((_, index) => index !== deleteIndex);
        return updatedData.map((item, i) => ({
          [`days_${i}`]: item[`days_${Object.keys(item)[0].split("_")[1]}`],
          [`percentage_${i}`]:
            item[`percentage_${Object.keys(item)[1].split("_")[1]}`],
        }));
      });

      setDeleteIndex(null);
      setShowDeleteModal(false);
    }
  };

  const formatTime = (time) => {
    if (!time) return "";
    const timeParts = time.split(":");

    if (timeParts.length !== 2) return time;
    const [hours, minutes] = timeParts;
    const formattedHours = (hours || "").padStart(2, "0");
    const formattedMinutes = (minutes || "").padStart(2, "0");

    return `${formattedHours}:${formattedMinutes}`;
  };

  const confirmDelete = (index) => {
    setDeleteIndex(index);
    setShowDeleteModal(true);
  };

  return (
    <div className="col-span-full relative">
      <div className="grid xl:grid-cols-3 lg:grid-cols-1 gap-5 mb-3 col-span-8">
        <div className="hidden xl:block">
          <LabelArea label="Days" required />
        </div>
        <div className="hidden xl:block">
          <LabelArea label="Percentage" required />
        </div>
      </div>

      {dataInput.map((val, i) => (
        <div
          key={i}
          className="grid xl:grid-cols-3 lg:grid-cols-1 gap-5 mb-3 col-span-8"
        >
          {(tab === 0 || tab === 2 || tab === 3 || tab || 4) && (
            <div>
              <InputArea
                register={register}
                name={`days_${i}`}
                min="0"
                max="31"
                label="Days"
                type="number"
                inputMode="numeric"
                value={val[`days_${i}`]}
                onChange={(e) => handleChangeInput(e, i)}
                placeholder="Days"
                allowZero={true}
              />
              <Error errorName={errors[`days_${i}`]} />
            </div>
          )}
          {tab === 1 && (
            <div>
              <InputArea
                register={register}
                name={`days_${i}`}
                label="Hours"
                type="time"
                value={formatTime(val[`days_${i}`])}
                onChange={(e) => handleChangeInput(e, i)}
                placeholder="HH:MM"
              />
              <Error errorName={errors[`days_${i}`]} />
            </div>
          )}
          <div>
            <InputArea
              register={register}
              name={`percentage_${i}`}
              label="Percentage"
              type="number"
              min="0"
              max="100"
              inputMode="numeric"
              value={val[`percentage_${i}`]}
              onChange={(e) => handleChangeInput(e, i)}
              placeholder="Percentage"
            />
            <Error errorName={errors[`percentage_${i}`]} />
          </div>
          <div className="flex items-center">
            {dataInput.length > 1 && (
              <button
                style={{ top: "1rem", outline: "none", color: "grey" }}
                className="ml-8 outline-none"
                type="button"
                aria-label="Remove item"
                onClick={() => confirmDelete(i)} // Pass the correct index
              >
                X
              </button>
            )}
          </div>
        </div>
      ))}

      <div className="mt-6 lg:mt-1">
        <button
          style={{
            bottom: "-15px",
            color: "#0e9f6e",
            fontSize: "42px",
            outline: "none",
          }}
          className="absolute right-0 outline-none"
          type="button"
          onClick={handleClick}
        >
          +
        </button>
      </div>

      <ConfirmDeleteModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleDelete}
      />
    </div>
  );
};

export default DynamicCancellationPolicy;
